import { SidebarMenu, SidebarMenuItem } from "../../components/ui/sidebar"
import SummerYouLogo from "../../assets/output-onlinepngtools (2).png"
import SummerYouAltLogo from "../../assets/output-onlinepngtools (1).png"
export const NavHeader = () => {
  return(
    <SidebarMenu>
      <SidebarMenuItem>
        
          <div className="flex items-center justify-center p-2  group-data-[collapsible=icon]:p-0">
            <img
              src={SummerYouLogo}
              alt="SummerYou logo"
              className="w-48 h-auto  object-contain 
                     group-data-[collapsible=icon]:hidden"
            />

            {/* Small icon (only visible when collapsed) */}
            <img
            src={SummerYouAltLogo}
            alt="SummerYou icon"
            className="hidden group-data-[collapsible=icon]:block size-10 object-contain"
            />
          </div>
          
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
